module.exports = __webpack_public_path__ + "img/BRCA2_NK.ddca2b7a.png";